import { useState, useEffect } from "react";
import { getEmployeeProjectsAPI } from "../services/employee";

function UseEmpsProject(orgId) {
  const [data, setData] = useState([]);
  useEffect(() => {
    const getData = async () => {
      const result = await getEmployeeProjectsAPI({ orgId });
      if (!result) return;

      const newData = result.result.map((d, i) => {
        return { value: d?.project_id, label: d?.project_name || d?.project_name_en };
      });

      setData(newData);
    };
    if (orgId) {
      getData();
    }
  }, [orgId]);

  return data;
}

export default UseEmpsProject;
